import { getValidation } from 'commonsUtilities/validations';
import md5 from 'js-md5';
import { getAliasesDocumentType } from 'utilities/multiLanguageHelper';

export const validateDocNumber = ({ docNumber, documentType }) => {
    const validation = getValidation(docNumber, documentType);

    return validation.valid;
};

export const validateInvitationDocNumberMatch = (docType, docNumber, invitationDocNumber) => {
    const doc = md5(getAliasesDocumentType(docType) + docNumber);

    return doc === invitationDocNumber;
};
